import {
  Box,
  Button,
  FormLabel,
  Input,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { middleEarthService } from "Apis/middleEarthApi";
import { WashedForm } from "Components/UI/WashedForm";
import { motion } from "motion/react";
import { portalUrlAfterLogin } from "features/login/samlAuthStartUrl";
import { useNotification } from "Hooks";

const SamlLoginForm = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const location = useLocation<{ from?: string }>();
  const { showErrorNotification } = useNotification();

  const handleContinue = async () => {
    const trimmed = email.trim();
    if (!trimmed) {
      showErrorNotification("Enter your email address");
      return;
    }
    const from = location.state?.from || "";
    setSubmitting(true);
    try {
      const { login_url: loginUrl } = await middleEarthService.getSamlLoginUrl({
        email: trimmed,
        redirect: portalUrlAfterLogin(from),
      });
      if (!loginUrl?.trim()) {
        showErrorNotification("Could not start SAML sign-in");
        setSubmitting(false);
        return;
      }
      window.location.assign(loginUrl);
    } catch {
      setSubmitting(false);
      showErrorNotification("Could not start SAML sign-in");
    }
  };

  return (
    <WashedForm>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { delay: 0.2 },
        }}
        exit={{
          x: 300,
          opacity: 0,
          transition: { duration: 0.3 },
        }}
      >
        <Stack spacing={2}>
          <Typography variant="subtitle1" color="common.white">
            Sign in with SSO using SAML
          </Typography>
          <Typography color="common.white" variant="body2" mb={2}>
            Enter your work email; you will be redirected to your organization
            to complete sign-in.
          </Typography>
          <div>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              autoComplete="email"
            />
          </div>
        </Stack>

        <Box mt={4} mb={2}>
          <Button
            onClick={handleContinue}
            disabled={submitting}
            variant="contained"
            fullWidth
            color="primary"
            size="large"
          >
            Continue
          </Button>
        </Box>

        <Box mt={1} display="flex" justifyContent="flex-end">
          <Typography color="white" fontWeight={500}>
            Use password instead?
            <Typography component="span" ml={1}>
              <Link to="/login" color="primary">
                Sign in
              </Link>
            </Typography>
          </Typography>
        </Box>
      </motion.div>
    </WashedForm>
  );
};

export default SamlLoginForm;
